import '@/styles/application.scss'
import App from './App.vue'
import Interceptors from '@/plugins/interceptors'
import Vue from 'vue'
import i18n from '@/plugins/vue-i18n'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/fragment';
import routes from './router/routes';
import Router from 'vue-router';

Vue.config.productionTip = false

const interceptors = Interceptors(store);
Vue.use(Router);

const routerInstance = new Router({
  mode: 'history',
  routes,
});

routerInstance.beforeEach((to, from, next) => {
  localStorage.setItem('currentUrl', to.path);
  next(); // Permitir la navegación
});

new Vue({
  router: routerInstance,
  store,
  vuetify,
  i18n,
  interceptors,
  render: h => h(App)
}).$mount('#app')

export default routerInstance;